// @flow
import type { StripeCardFunding } from "./types"

export const stripeCardFunding: {[StripeCardFunding]: StripeCardFunding} = {
  credit: "credit",
  debit: "debit",
  prepaid: "prepaid",
  unknown: "unknown",
}



// WEBPACK FOOTER //
// ./src/data/stripe/constants.js